import React, {Component} from "react"
import styles from "./Loader.module.css"
import felbryCollegeLogo from "./img/felbrycollege-logo.jpg"

interface Props {
    isVisible: boolean
}

export class Loader extends Component<Props, {}> {
    public render() {
        const {isVisible} = this.props
        return (
            <div
                className={`${styles.loadingContainer} ${
                    isVisible ? styles.visible : styles.invisible
                }`}>
                <img src={felbryCollegeLogo} alt="felbryCollegeLogo" />
                <div className={styles.LoaderBars}>
                    <div className={styles.Bar}></div>
                    <div className={styles.Bar}></div>
                    <div className={styles.Bar}></div>
                </div>
            </div>
        )
    }
}
